<template>
    <div
        v-if="
            integration.data.length !== 0 &&
            integration.type === 'MICROSOFT_TEAMS'
        "
        class="rounded-lg border-iron-200 p-4 grid w-full grid-cols-12 border"
    >
        <div
            :class="[deletable ? 'col-span-10' : 'col-span-12']"
            class="flex w-full items-center justify-between"
        >
            <div
                class="rounded-lg bg-white shadow-sm mr-3 flex h-[40px] w-[40px] items-center justify-center"
            >
                <MicrosoftTeamsLogo class="w-6 h-6" />
            </div>

            <div class="grow">
                <p class="text-sm font-medium text-iron-700">
                    {{ integration.data.name }}
                </p>
                <p class="text-xs text-iron-500">
                    {{ integration.data.email }}
                </p>
            </div>
        </div>

        <div
            v-if="deletable"
            class="gap-4 col-span-2 flex items-center justify-end"
        >
            <Button variant="destructive" @click="removeIntegration" size="sm">
                <Trash :size="16" />
            </Button>
        </div>

        <div class="col-span-12"></div>
    </div>
</template>

<script setup lang="ts">
import { router } from "@inertiajs/vue3";
import MicrosoftTeamsLogo from "../logos/simple/MicrosoftTeams.svg";
import useConfirm from "../../../ConfirmDialog/composables/useConfirm";
import { useI18n } from "vue-i18n";
import { Trash } from "lucide-vue-next";
import { Button } from "@/components/ui/button";

interface Props {
    integration: any;
    deletable?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
    deletable: true,
});

const { show } = useConfirm();
const { t } = useI18n();

async function removeIntegration() {
    const ok = await show({
        header: t("integrations.delete.header") + ": Microsoft Teams",
        message: t("integrations.delete.message"),
        confirm: t("integrations.delete.confirm"),
        cancel: t("integrations.delete.cancel"),
    });

    if (ok) {
        await router.delete(
            `/integrations/microsoft-teams/${props.integration.id}`,
        );
    }
}
</script>
